import { Link } from "react-router-dom";
import logo from "../../assets/ford-footer.png"
const RequestPermission = () => {
  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center bg-gray-100">
      {/* Ford Logo */}
      <img src={logo} alt="Ford Logo" className="mb-6 w-40 h-auto" />

      {/* Requesting Text */}
      <div className="text-center text-lg text-gray-800 flex justify-center items-center">
        <p className="font-semibold">
          It Seems You Don't Have Access for this Page. You can access the Request
        </p>
        <span className="ml-1">
          <Link 
            to="https://www.accessmgmt.dealerconnection.com/CspsWeb/cspsHomePost.do"
            className="text-blue-500 hover:text-blue-700"
          >
            Here
          </Link>
        </span>
      </div>
    </div>
  );
};

export default RequestPermission;
